// src/context/UserContext.js
import React, { createContext, useState, useEffect } from"react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    console.log("UserContext: user state changed:", user);
  }, [user]);

 return (
 <UserContext.Provider value={{ user, setUser }}>
 {children}
 </UserContext.Provider>
 );
};



